const JsSlick = {
	init () {

		/*
		* Slick Sliders
		*/

		$(".regular").slick({
			dots: false,
			infinite: true,
			slidesToShow: 6,
			slidesToScroll: 1,
			arrows:true
		});

		$(".center").slick({
			dots: false,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			arrows:true
		});

		$(".variable").slick({
			dots: false,
			infinite: true,
			variableWidth: true
		});

		$('.responsive').slick({
			dots: false,
			// infinite: true,
			speed: 300,
			slidesToShow: 6,
			slidesToScroll: 1,

			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						infinite: true,
						slidesToScroll: 1,
						infinite: true,
						dots: true
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 2,
						infinite: true,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 2,
						infinite: true,
						slidesToScroll: 1
					}
				}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			]
		});

	}
};

export default JsSlick;


// WEBPACK FOOTER //
// ./src/js/aras-kids-modules/slick.js